import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "@docma-mm-core/config/config.service";
import { BasedataService } from "@docma-mm-core/shared/basedata.service";
import { catchError, Observable } from "rxjs";
import { ProjectSetting } from "./project-setting";


@Injectable()
export class ProjectSettingsService extends BasedataService {

  private projectUrl: string = '/projects/';
  private settingsUrl: string = '/settings';

  constructor(private http: HttpClient, configService: ConfigService) {
    super(configService);
  }

  private getProjectSettingsUrl(projectId: number): string {
    return super.getFullUrl(this.projectUrl + projectId + this.settingsUrl)
  }

  getProjectSettings(projectId: number, top: number = 10000, skip: number = 0): Observable<ProjectSetting[]> {
    let endpoint = this.getProjectSettingsUrl(projectId);
    let httpParams = new HttpParams();
    if (top) httpParams = httpParams.set('$top', top.toString());
    if (skip) httpParams = httpParams.set('$skip', skip.toString());

    return this.http
      .get<any>(endpoint, {headers: this.getHeaders(), params: httpParams})
      .pipe(catchError(e  => this.handleError(e)));
  }

}
